import { render, staticRenderFns } from "./DIVEMetadataEditKey.vue?vue&type=template&id=47b8e944"
import script from "./DIVEMetadataEditKey.vue?vue&type=script&lang=ts"
export * from "./DIVEMetadataEditKey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports